import { CheckCircle, XCircle } from "lucide-react";

export default function Specifications() {
  const specs = [
    {
      category: "Interior",
      available: true,
      details: [
        "Leather Seats",
        "Ambient Lighting",
        "Adjustable Steering",
        "Rear Armrest",
      ],
      images: [
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",

        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",

        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",


        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",

        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
      ],
    },
    {
      category: "Exterior",
      available: true,
      details: ["LED Headlights", "Alloy Wheels", "Sunroof", "Fog Lamps"],
      images: [
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
        "https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png",
      ],
    },
    {
      category: "Music System",
      available: true,
      details: ["Bluetooth Connectivity", "USB Support", "FM/AM Radio"],
      images: ["https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/vehicles/1772534128933-4.png"],
    },
    {
      category: "Navigation",
      available: false,
      details: [],
      images: [],
    },
  ];

  return (
    <div className="bg-white rounded-xl shadow p-6">
      <h2 className="text-xl font-semibold mb-6">Car Specifications</h2>

      <div className="overflow-x-auto">
        <table className="w-full border border-gray-200 rounded-lg">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left p-3 text-sm font-semibold text-gray-700">
                Feature
              </th>
              <th className="text-center p-3 text-sm font-semibold text-gray-700">
                Available
              </th>
              <th className="text-left p-3 text-sm font-semibold text-gray-700">
                Details
              </th>
              {/* <th className="text-left p-3 text-sm font-semibold text-gray-700">
                Images
              </th> */}
            </tr>
          </thead>

          <tbody>
            {specs.map((item, index) => (
              <tr key={index} className="border-t">
                <td className="p-3 font-medium text-gray-800">
                  {item.category}
                </td>

                <td className="p-3 text-center">
                  {item.available ? (
                    <CheckCircle className="text-green-500 mx-auto" size={20} />
                  ) : (
                    <XCircle className="text-red-500 mx-auto" size={20} />
                  )}
                </td>

                <td className="p-3 text-sm text-gray-600">
                  {item.available ? (
                    <ul className="list-disc ml-4 space-y-1">
                      {item.details.map((detail, i) => (
                        <li key={i}>{detail}</li>
                      ))}
                    </ul>
                  ) : (
                    <span className="text-gray-400">Not Available</span>
                  )}
                </td>

                {/* <td className="p-3 w-[500px]">
                  {item.images?.length > 0 ? (
                    <div className="flex gap-2 flex-wrap">
                      {item.images.map((img, i) => (
                        <img
                          key={i}
                          src={img}
                          alt="spec"
                          className="w-10 h-10 object-cover rounded border"
                        />
                      ))}
                    </div>
                  ) : (
                    <span className="text-gray-400 text-sm">No Images</span>
                  )}
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}